import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";
const Main = lazy(
  () => import("../../components/settings/corporateDiscountRate/main")
);

const CorporateDiscountRate = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main />
    </Suspense>
  );
};

export default CorporateDiscountRate;
